import dayjs from '@/services/date/index'
import BookingClientViewModel from './bookingClientViewModel'
import BookingClientGroupViewModel from './bookingClientGroupViewModel'
import BookingCreatedByViewModel from './bookingCreatedByViewModel'
import BookingLocationViewModel from './bookingLocationViewModel'
import PendingBookingSummaryDetailsViewModel from './pendingBookingSummaryDetailsViewModel'

export default class PendingBookingSummaryViewModel {
  constructor(params) {
    this.id = params.id
    this.status = params.status
    this.createdBy = params.createdBy
      ? new BookingCreatedByViewModel(params.createdBy)
      : null
    this.createdOnUtc = params.createdOnUtc ? dayjs(params.createdOnUtc) : null
    this.days = params.days
    this.client = params.client
      ? new BookingClientViewModel(params.client)
      : null
    this.clientGroup = params.clientGroup
      ? new BookingClientGroupViewModel(params.clientGroup)
      : null
    this.location = params.location
      ? new BookingLocationViewModel(params.location)
      : null
    this.details = params.details
      ? new PendingBookingSummaryDetailsViewModel(params.details)
      : null
  }
}
